import { useLocation } from 'Services/router';

export const useIsPreview = () => {
  const { pathname } = useLocation();

  return (
    pathname.includes('/preview-article/') ||
    pathname.includes('/preview-news/')
  );
};
